export default "__VITE_ASSET__DQCa5nat__"